export function getRequestedViewForDrawingView(view) {
  if (!view) return "iso";

  if (view.type === "section") {
    return "section";
  }

  return view.type || "iso";
}

function hasSaved3DCamera(view, is3DView) {
  return Boolean(
    is3DView &&
      view?.camera &&
      view.camera.position &&
      view.camera.target
  );
}

export function buildSceneViewSettingsFromDrawingView(view, isActive = false, viewport = null) {
  const requestedView = getRequestedViewForDrawingView(view);

  const is3DView =
    requestedView === "iso" ||
    view?.cameraType === "perspective";

  const saved3DCamera = hasSaved3DCamera(view, is3DView);

  const scale = Number(view?.scale || 20);
  const viewMode = view?.viewMode || "hiddenLine";

  const viewportWidthMm = Number(viewport?.widthMm ?? viewport?.width ?? 100);
  const viewportHeightMm = Number(viewport?.heightMm ?? viewport?.height ?? 80);

  const cameraToken = is3DView
  ? `${view?.camera?.target?.x ?? "auto"}_${view?.camera?.target?.y ?? "auto"}_${view?.camera?.target?.z ?? "auto"}`
  : "fixed_2d";

  const sectionToken = view?.sectionPlane
  ? [
      view.sectionPlane.axis,
      view.sectionPlane.value,
      view.sectionPlane.direction,
      view.sectionPlane.depth,
      view.sectionPlane.angleDeg,
      view.sectionPlane.start?.x,
      view.sectionPlane.start?.z,
      view.sectionPlane.end?.x,
      view.sectionPlane.end?.z,
    ].join("_")
  : "no_section";

  return {
    cameraType: view?.cameraType || "orthographic",

    requestedView: is3DView && !saved3DCamera
  ? {
      view: requestedView,
      token: `${view?.id || "view"}_${requestedView}_${scale}_${viewMode}_${viewportWidthMm}_${viewportHeightMm}_${sectionToken}_${cameraToken}`,
    }
  : null,

requestedAction: is3DView && !saved3DCamera
  ? {
      type: "fitAll",
      token: `${view?.id || "view"}_fit_${requestedView}_${scale}_${viewMode}_${viewportWidthMm}_${viewportHeightMm}_${sectionToken}_${cameraToken}`,
    }
  : null,

    showGrid: false,
    showGizmo: false,
    showCoordinateSystems: false,
    showMountingDrillings: false,

    sectionPlane: view?.sectionPlane || null,

    lockStandardView: !is3DView,
    exactDrawingScale: !is3DView,

    allowRotate: is3DView,
allowZoom: is3DView,
allowPan: is3DView,

    disableAutoFocusSelected: true,

    drawingScale: scale,

    projection: view?.projection || {
  originWorld: { x: 0, y: 0, z: 0 },
},

requestedProjection: !is3DView
  ? {
      view: requestedView,
      token: `${view?.id || "view"}_projection_${requestedView}_${scale}_${viewMode}_${viewportWidthMm}_${viewportHeightMm}_${sectionToken}_${JSON.stringify(view?.projection?.originWorld || { x: 0, y: 0, z: 0 })}`,
    }
  : null,

    viewportPaperSizeMm: {
      width: viewportWidthMm,
      height: viewportHeightMm,
    },

   viewCamera: is3DView ? view?.camera || null : null,

    ambientIntensity: 1,
    mainLightIntensity: 0.8,
  };
}

export const SHEET_PREVIEW_PX_PER_MM = 3;

export function normalizeViewportLayout(viewport = {}) {
  const hasMm =
    viewport.xMm !== undefined ||
    viewport.yMm !== undefined ||
    viewport.widthMm !== undefined ||
    viewport.heightMm !== undefined;

  if (hasMm) {
    return {
      xMm: Number(viewport.xMm ?? 0),
      yMm: Number(viewport.yMm ?? 0),
      widthMm: Number(viewport.widthMm ?? 100),
      heightMm: Number(viewport.heightMm ?? 80),
    };
  }

  return {
    xMm: Number(viewport.x ?? 0) / SHEET_PREVIEW_PX_PER_MM,
    yMm: Number(viewport.y ?? 0) / SHEET_PREVIEW_PX_PER_MM,
    widthMm: Number(viewport.width ?? 300) / SHEET_PREVIEW_PX_PER_MM,
    heightMm: Number(viewport.height ?? 200) / SHEET_PREVIEW_PX_PER_MM,
  };
}

export function getViewportStyle(
  viewport,
  isActive,
  selected = false,
  dragging = false,
  pxPerMm = SHEET_PREVIEW_PX_PER_MM
) {
  const layout = normalizeViewportLayout(viewport);

  const border = isActive
    ? "2px solid #2563eb"
    : selected
      ? "2px solid #38bdf8"
      : "1px solid #94a3b8";

  const boxShadow = isActive
    ? "0 0 0 3px rgba(37, 99, 235, 0.18)"
    : selected
      ? "0 0 0 3px rgba(56, 189, 248, 0.16)"
      : "0 1px 2px rgba(15, 23, 42, 0.12)";

  return {
    position: "absolute",
    left: layout.xMm * pxPerMm,
    top: layout.yMm * pxPerMm,
    width: layout.widthMm * pxPerMm,
    height: layout.heightMm * pxPerMm,
    background: "white",
    overflow: "hidden",
    border,
    boxShadow,
    opacity: dragging ? 0.92 : 1,
    zIndex: 10,
  };
}